module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row gutters-tiny"
  }, [_c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "orders",
      "label": "Bestellingen",
      "icon": "basket"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "refunds",
      "label": "Retouren",
      "icon": "control-rewind",
      "icon-class": "text-danger"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "products",
      "label": "Producten",
      "icon": "tag",
      "icon-class": "text-Pulse"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "users",
      "label": "Gebruikers",
      "icon": "people",
      "icon-class": "text-corporate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "sales-channels",
      "label": "Verkoopkanalen",
      "icon": "share",
      "icon-class": "text-success"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-xl-2"
  }, [_c('tile', {
    attrs: {
      "route": "settings",
      "label": "Instellingen",
      "icon": "wrench",
      "icon-class": "text-elegance"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62425eac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/AdminDashboard.vue
// module id = 724
// module chunks = 1